import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { VisitWish } from 'App/ReservationBook/Screens/VisitWishes/visitWishApi';
import { visitWishReservationDate } from 'utils/visitWishReservation';
import { dateHelper } from 'utils/helper';
import useToast from './useToast';
import { Severity } from 'Contexts/RestaurantContext';

export default function useVisitWishReservation(restaurantId: string) {
  const history = useHistory();
  const toast = useToast();
  return useCallback((wish: VisitWish, selectedDate?: string) => {
    const date = wish.staffReservation?.date ?? visitWishReservationDate(wish, dateHelper(), selectedDate);
    if (!date) {
      toast('Für diese Anfrage liegt kein zukünftiger Termin vor.', Severity.WARNING);
      return;
    }
    history.push(`/${restaurantId}/reservations/${date}/tablePlan?tab=waitinglist&visitWishId=${encodeURIComponent(wish.id)}`);
  }, [history, restaurantId, toast]);
}
